import { Flex, Text } from "@chakra-ui/react";
import { IconContainer } from "./styles";
import { MdOutlineSettings } from "react-icons/md";

function Header() {
  return (
    <Flex
      as="header"
      w="100%"
      justifyContent="space-between"
      h="24"
      px="12"
      borderColor="gray.500"
      boxShadow="0px 1px 4px #0000007D"
    >
      <Flex flexDir="row" alignItems="center">
        <IconContainer>
          <MdOutlineSettings size={32} color="#fff" />
        </IconContainer>
        <Text
          fontSize="26px"
          fontWeight="medium"
          letterSpacing="tight"
          justifyContent="center"
          color="#676C77"
          ml="2"
        >
          Configuração de Filtros de Culturas
        </Text>
      </Flex>
    </Flex>
  );
}

export default Header;
